import React from 'react';

// Types
import { MetricSlugs } from '../ManagerDashboardData.constants';

// Constants
import { ManagerDashboardLearnMoreData } from '../ManagerDashboardData.constants';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import { WpContainer, WpContainerHeader, WpContainerBody } from 'Wpds/components/container';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';
import ManagerDashboardLearnMoreModal from '../ManagerDashboardLearnMoreModal';

// Styles
import './MetricsWrapper.scss';

type Props = {
  slug: MetricSlugs;
  children: React.ReactNode;
};

const MetricsWrapper = ({ slug, children }: Props) => {
  const [isLearnMoreModalOpen, toggleIsLearnMoreModalOpen] = useToggle(false);

  const data = ManagerDashboardLearnMoreData.find(item => item.slug === slug);

  const baseClassName = 'MetricsWrapper';
  return (
    <>
      <div className={baseClassName}>
        {data.label && <p className={`${baseClassName}__label`}>{data.label}</p>}
        <WpContainer>
          <WpContainerHeader>
            <div className={`${baseClassName}__title`}>
              <h5>{data.title}</h5>
              {slug && (
                <div className={`${baseClassName}__learn-more-button`}>
                  <WpButton variant="tertiary" size="sm" onClick={toggleIsLearnMoreModalOpen}>
                    <WpIcon name="info-circle" />
                  </WpButton>
                </div>
              )}
            </div>
          </WpContainerHeader>
          <WpContainerBody>{children}</WpContainerBody>
        </WpContainer>
      </div>
      <ManagerDashboardLearnMoreModal
        slug={slug}
        isOpen={isLearnMoreModalOpen}
        toggleOpen={toggleIsLearnMoreModalOpen}
      />
    </>
  );
};

export default MetricsWrapper;
